import { fieldWithTranslationSchema, numberSchema } from "components/inputs/validationSchema";
import { TFunction } from "i18next";
import * as yup from "yup";

export const fieldNames = {
  title: "title",
  listOrderNumber: "listOrderNumber",
} as const;

export const validation = (id: string | undefined, t: TFunction) => {
  return yup.object().shape({
    [fieldNames.title]: fieldWithTranslationSchema(fieldNames.title, t),
    [fieldNames.listOrderNumber]: numberSchema(fieldNames.listOrderNumber, t),
  });
};
